var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-select',{staticClass:"ma-0 pa-0",attrs:{"items":_vm.items,"item-value":"value","item-text":"text","hide-details":"","outlined":"","dense":"","label":"Switch algo","disabled":_vm.disabled},model:{value:(_vm.localAlgoType),callback:function ($$v) {_vm.localAlgoType=$$v},expression:"localAlgoType"}})
}
var staticRenderFns = []

export { render, staticRenderFns }